module.exports = __webpack_public_path__ + "static/media/screenSnap1.47722537.jpg";